


import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const reportService = {
  get_report_service: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.GET_REPORT_SERVICE}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  get_report_profile: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.GET_REPORT_PROFILE}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  get_report_finance: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.GET_REPORT_FINANCE}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  get_report_original_profile: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.GET_REPORT_ORIGINAL_PROFILE}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  get_report_service_of_customer: async (token, params, customerId) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.GET_REPORT_SERVICE_OF_CUSTOMER.replace(":customerId", customerId)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  get_report_finance_of_customer: async (token, params, customerId) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.GET_REPORT_FINANCE_OF_CUSTOMER.replace(":customerId", customerId)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  get_report_profile_of_customer: async (token, params, customerId) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.GET_REPORT_PROFILE_OF_CUSTOMER.replace(":customerId", customerId)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );
    return response;
  },
  // check lại rồi UPDATE 
  export_pdf: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.EXPORT_PDF}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
        responseType: "blob",
      }
    );
    return response;
  },
  export_original_profile_pdf: async (token, params) => {
    const response = await https.get(
      `${API_ROUTES.REPORT.EXPORT_ORIGINAL_PROFILE_PDF}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
        responseType: "blob",
      }
    );
    return response;
  },
};
